import { Star, BadgeCheck, CreditCard, PackageCheck, Wrench } from "lucide-react";
import { Reveal } from "./Shared";

const ITEMS = [
  { icon: BadgeCheck, title: "Garantía por escrito", sub: "En cada compra" },
  { icon: Wrench, title: "Servicio técnico", sub: "Por 1 año" },
  { icon: CreditCard, title: "Financiamiento", sub: "Planes vigentes disponibles" },
  { icon: PackageCheck, title: "Importados", sub: "Las mejores marcas" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="border-b border-border bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-5">
        <Reveal className="col-span-2 border-b border-border p-6 md:p-8 lg:col-span-1 lg:border-b-0 lg:border-r">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
            ))}
          </div>
          <p className="mt-3 text-sm font-extrabold text-primary">4.6 en Google</p>
          <p className="text-xs text-muted-foreground">Clientes satisfechos en San Pedro Sula</p>
        </Reveal>
        {ITEMS.map((item, i) => (
          <Reveal
            key={item.title}
            delay={0.06 * (i + 1)}
            className="border-b border-border p-6 last:border-b-0 md:p-8 lg:border-b-0 lg:border-r lg:last:border-r-0"
          >
            <item.icon className="h-6 w-6 text-primary" />
            <p className="mt-3 text-sm font-extrabold text-primary">{item.title}</p>
            <p className="text-xs text-muted-foreground">{item.sub}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
